export const environment = {
    production: false,
    api: 'https://stg-api-cms-merchant.wepay4u.com/api/v1/',
    apiS3: 'https://stg-merchant-file.s3.amazonaws.com/',
};

